import { Injectable } from '@angular/core';

type ResetCallback = () => void;

/**
 * Реестр runtime-кэшей, которые нужно очищать при смене пользователя/логауте.
 */
@Injectable({ providedIn: 'root' })
export class AppRuntimeCacheRegistryService {
  private readonly callbacks = new Set<ResetCallback>();

  public register(callback: ResetCallback): () => void {
    this.callbacks.add(callback);
    return () => this.callbacks.delete(callback);
  }

  public clearAll(): void {
    for (const callback of this.callbacks) {
      callback();
    }
  }
}
